import {GUEST_STATUSES, ShortGuest} from '@guestapp/sdk';
import {sanitizeStringFromDashes} from 'utils/common';
import {useFetchParticipants} from 'hooks/auth/useFetchParticipants';
import {useSummary} from 'context/summary';
import {useAuth} from 'hooks/auth/useAuth';

type Props = {
  member: ShortGuest;
};
function useIsEditableMember({member}: Props) {
  const {data: participants} = useFetchParticipants();
  const {isLoggedIn} = useAuth();
  const {isInstantCheckInEnabled} = useSummary();
  const isPreRegistered = member.is_pre_registered;
  const baseCondition =
    isPreRegistered && member.guestapp_status === GUEST_STATUSES.incomplete;
  const isVerificationPending =
    member.guestapp_status === GUEST_STATUSES.verification_pending;

  const isMemberCreateByUser = participants?.some(
    participant =>
      sanitizeStringFromDashes(participant.id) ===
      sanitizeStringFromDashes(member.participant_id),
  );

  const noInstantChekinConditions = [baseCondition, isVerificationPending];
  const instantChekinConditions = [
    isLoggedIn && isMemberCreateByUser && (baseCondition || isVerificationPending),
  ];

  const conditions = isInstantCheckInEnabled
    ? instantChekinConditions
    : noInstantChekinConditions;

  const isEditable = conditions.some(Boolean);
  return {isEditable};
}

export {useIsEditableMember};
